var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTaskDue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.8594,
    r: 12.5,
    fill: "#FFE1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23873 18.047C8.12571 18.047 8.01732 18.0021 7.9374 17.9222C7.85749 17.8422 7.81259 17.7338 7.81259 17.6208V9.0981C7.81259 8.98508 7.85749 8.87669 7.9374 8.79678C8.01732 8.71686 8.12571 8.67196 8.23873 8.67196L17.1876 8.67196H17.8268C17.9963 8.67196 18.1589 8.60462 18.2788 8.48475C18.3987 8.36487 18.466 8.20229 18.466 8.03276C18.466 7.86323 18.3987 7.70065 18.2788 7.58077C18.1589 7.4609 17.9963 7.39355 17.8268 7.39355L8.23873 7.39355C7.78665 7.39355 7.35309 7.57314 7.03343 7.8928C6.71377 8.21247 6.53418 8.64603 6.53418 9.0981V17.6208C6.53418 18.0729 6.71377 18.5065 7.03343 18.8261C7.35309 19.1458 7.78665 19.3254 8.23873 19.3254H16.7615C17.2135 19.3254 17.6471 19.1458 17.9667 18.8261C18.2864 18.5065 18.466 18.0729 18.466 17.6208V8.03276C18.466 7.86323 18.3987 7.70065 18.2788 7.58077C18.1589 7.4609 17.9963 7.39355 17.8268 7.39355C17.6573 7.39355 17.4947 7.4609 17.3748 7.58077C17.2549 7.70065 17.1876 7.86323 17.1876 8.03276V8.67196V17.6208C17.1876 17.7338 17.1427 17.8422 17.0628 17.9222C16.9829 18.0021 16.8745 18.047 16.7615 18.047H8.23873Z",
    fill: "#EF4E38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1876 8.67196H17.8268C17.9963 8.67196 18.1589 8.60462 18.2788 8.48475C18.3987 8.36487 18.466 8.20229 18.466 8.03276C18.466 7.86323 18.3987 7.70065 18.2788 7.58077C18.1589 7.4609 17.9963 7.39355 17.8268 7.39355C17.6573 7.39355 17.4947 7.4609 17.3748 7.58077C17.2549 7.70065 17.1876 7.86323 17.1876 8.03276V8.67196Z",
    fill: "#EF4E38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaskDue);
export default __webpack_public_path__ + "static/media/icon-task-due.030cd8622e1c2d5f3bae0b432884e3e1.svg";
export { ForwardRef as ReactComponent };